/**
 * T16: Helpers for handling AI 503 errors in UI components.
 * Pure functions — testable without React.
 */

/** True when the backend returned 503 (AI overloaded / parse failure). */
export function is503(err: unknown): boolean {
  return (err as any)?.response?.status === 503
}

/**
 * Extract human-readable detail from an Axios-like error.
 * Priority: response.data.detail > err.message > fallback string.
 */
export function getErrorDetail(err: unknown): string {
  const detail = (err as any)?.response?.data?.detail
  if (detail) return String(detail)
  const message = (err as any)?.message
  if (message) return String(message)
  return 'Неизвестная ошибка'
}